import { render, staticRenderFns } from "./TreasureRefining.vue?vue&type=template&id=b682a966&scoped=true"
import script from "./TreasureRefining.vue?vue&type=script&lang=js"
export * from "./TreasureRefining.vue?vue&type=script&lang=js"
import style0 from "./TreasureRefining.vue?vue&type=style&index=0&id=b682a966&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b682a966",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cmdgame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b682a966')) {
      api.createRecord('b682a966', component.options)
    } else {
      api.reload('b682a966', component.options)
    }
    module.hot.accept("./TreasureRefining.vue?vue&type=template&id=b682a966&scoped=true", function () {
      api.rerender('b682a966', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/refining/TreasureRefining.vue"
export default component.exports